import payment from "./payment/reducer"
import formPayment from "./formPayment/reducer"
export default {
  SuperSchoolMemoryPayment: payment,
  SuperSchoolMemoryFormPayment: formPayment,
}
